import { TFunction } from 'i18next';
import { toast } from 'react-toastify';
import getServerName from './getServerName';

export const redirectAuthFail = (t: TFunction) => {
  toast.error(t('errors.userAuth'));
  return window.location.replace(`https://${getServerName()}/logout`);
};
